import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { useMode, ColorModeContext } from "./components/Theme.js";
import Login from "./pages/login.js";
import FarmerInfo from "./pages/farmerInfo.js";
import Homepage from "./pages/homepage.js";
import GoogleMapsProvider from "./ProviderGooglemap.js";
import Registeration from "./pages/Registeration.js";
import Forgetpassword from "./pages/Forgetpassword.js";
import Policy from "./pages/policy.js";

function App() {
  const [theme, colorMode] = useMode();
  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div>
          <GoogleMapsProvider>
            <Router>
              <Routes>
                <Route path="*" element={<Navigate to="/" replace={true} />} />
                <Route path="/" element={<Navigate to="/login" />} />
                <Route path="/register" element={<Registeration />} />
                <Route path="/forgetpassword" element={<Forgetpassword />} />
                <Route path="/login" element={<Login />} />
                <Route path="/farmerInfo" element={<FarmerInfo />} />
                <Route path="/home" element={<Homepage />} />
                <Route path="/policy" element={<Policy />} />
              </Routes>
            </Router>
          </GoogleMapsProvider>
        </div>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}
export default App;
